import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateAdapter from '@mui/lab/AdapterMoment';
import DatePicker from '@mui/lab/DatePicker';
import moment from 'moment';
import CouponDetail from '../../components/ActiveCode/CouponDetail';
import TaxBillDetail from './TaxBillDetail';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import FreeCouponOrder from '../../components/Coupon/FreeCouponOrder';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'createdAt', label: '신청일자', minWidth: 120, align: 'center' },
  { id: `acCompanyName`, label: '회사명', minWidth: 200, align: 'center' },
  { id: `createdId`, label: '담당자ID', minWidth: 120, align: 'center' },
  { id: `createdName`, label: '담당자명', minWidth: 140, align: 'center' },
  { id: 'orderNo', label: '주문번호', minWidth: 150, align: 'center' },
  { id: 'prgStep', label: '진행상태', minWidth: 200, align: 'center' },
  // { id: 'companionAt', label: '반려', minWidth: 100, align: 'center' },
  { id: 'amount', label: '금액', minWidth: 100, align: 'right', format: (value) => value.toLocaleString('en-US') },
  { id: 'quantity', label: '사용권 수량', minWidth: 110, align: 'right', format: (value) => value.toLocaleString('en-US') },
  { id: 'taxbillAt', label: '계산서발행일', minWidth: 120, align: 'center' },
  { id: 'depositAt', label: '입금완료일', minWidth: 120, align: 'center' },
  { id: 'approvalAt', label: '코드발급일', minWidth: 120, align: 'center' },
  { id: 'cancelReqAt', label: '취소요청일', minWidth: 120, align: 'center' },
  { id: 'startDate', label: '사용시작일', minWidth: 120, align: 'center' },
  { id: 'endDate', label: '사용만료일', minWidth: 120, align: 'center' },
  { id: 'codeDate', label: '코드사용일', minWidth: 120, align: 'center' }
];
const columnsApproved = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'createdAt', label: '신청일자', minWidth: 120, align: 'center' },
  { id: 'orderNo', label: '주문번호', minWidth: 150, align: 'center' },
  { id: 'prgStep', label: '주문정보', minWidth: 200, align: 'center' },
  { id: 'orderGbn', label: '주문구분', minWidth: 100, align: 'center' },
  { id: `acCompanyName`, label: '회사명', minWidth: 200, align: 'center' },
  { id: `createdId`, label: '담당자ID', minWidth: 120, align: 'center' },
  { id: `createdName`, label: '담당자명', minWidth: 140, align: 'center' },
  { id: 'amount', label: '금액', minWidth: 100, align: 'right' },
  { id: 'quantity', label: '사용권수량', minWidth: 100, align: 'right' },
  { id: 'residualQuantity', label: '잔여수량', minWidth: 100, align: 'right' },
  { id: 'startDate', label: '사용시작일', minWidth: 120, align: 'center' },
  { id: 'endDate', label: '사용만료일', minWidth: 120, align: 'center' },
  { id: 'taxbillAt', label: '세금계산서', minWidth: 120, align: 'center' },
  { id: 'depositAt', label: '입금일', minWidth: 120, align: 'center' },
  { id: 'approvalAt', label: '코드발급', minWidth: 120, align: 'center' },
  { id: 'codeDate', label: '코드사용일', minWidth: 120, align: 'center' }
];

const columnsCancel = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'createdAt', label: '신청일자', minWidth: 120, align: 'center' },
  { id: 'orderNo', label: '주문번호', minWidth: 150, align: 'center' },
  { id: 'prgStep', label: '주문정보', minWidth: 200, align: 'center' },
  { id: `createdId`, label: '담당자ID', minWidth: 120, align: 'center' },
  { id: `acCompanyName`, label: '회사명', minWidth: 200, align: 'center' },
  { id: `createdName`, label: '담당자명', minWidth: 140, align: 'center' },
  { id: 'amount', label: '금액', minWidth: 100, align: 'right' },
  { id: 'quantity', label: '사용권 수량', minWidth: 110, align: 'right' },
  { id: 'taxbillAt', label: '세금계산서', minWidth: 120, align: 'center' },
  { id: 'depositAt', label: '입금일', minWidth: 120, align: 'center' },
  { id: 'approvalAt', label: '코드발급', minWidth: 120, align: 'center' },
  { id: 'cancelReqAt', label: '거래취소요청', minWidth: 150, align: 'center' },
  { id: 'cancelCmptAt', label: '거래취소완료', minWidth: 150, align: 'center' },
  { id: 'codeDate', label: '코드사용일', minWidth: 120, align: 'center' }
];

const columnsFree = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'createdAt', label: '발급일자', minWidth: 120, align: 'center' },
  { id: 'orderNo', label: '주문번호', minWidth: 150, align: 'center' },
  { id: 'orderGbn', label: '주문구분', minWidth: 100, align: 'center' },
  { id: `acCompanyName`, label: '회사명', minWidth: 200, align: 'center' },
  { id: `createdId`, label: '담당자ID', minWidth: 120, align: 'center' },
  { id: `createdName`, label: '담당자명', minWidth: 140, align: 'center' },
  { id: 'quantity', label: '사용권수량', minWidth: 100, align: 'right' },
  { id: 'residualQuantity', label: '잔여수량', minWidth: 100, align: 'right' },
  { id: 'startDate', label: '사용시작일', minWidth: 120, align: 'center' },
  { id: 'endDate', label: '사용만료일', minWidth: 120, align: 'center' },
  { id: 'codeDate', label: '코드사용일', minWidth: 120, align: 'center' }
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function ActiveCodeMng() {
  const date = new Date();
  const [srchData, setSrchData] = useState({
    startYmd: moment(date.getTime()).add('-1', 'y'),
    endYmd: moment()
  });

  const [openDetail, setOpenDetail] = useState(false);
  const [value, setValue] = useState(0);

  const [rows, setRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [selectedRow, setSelectedRow] = useState({});
  const [openTaxBill, setOpenTaxBill] = useState(false);
  const [openFreeCouponOrder, setOpenFreeCouponOrder] = useState(false);
  const offset = 10;

  const handleChangeSrch = (e) => {
    const id = e.target.id.replace('Srch', '');
    setSrchData((prev) => ({ ...prev, [id]: e.target.value }));
  };

  const getDataList = async () => {
    const { startYmd, endYmd, username } = srchData;

    if (!!!startYmd) {
      alert('발급 시작일을 입력해 주세요.');
      return;
    }
    if (!!!endYmd) {
      alert('발급 종료일을 입력해 주세요.');
      return;
    }

    let params = {
      offset,
      page: page,
      limit: offset,
      startYmd: startYmd.format('YYYYMMDD'),
      endYmd: endYmd.format('YYYYMMDD'),
      username,
      tabValue: value
    };

    const response = await axios.get(`/api/coupon/order`, { params });
    if (response.data) {
      const result = response.data;
      setPageCnt(Math.ceil(result.count / offset));
      setRows(result.rows);
    }
  };

  const handleCloseDetail = () => {
    setOpenDetail(false);
    setOpenTaxBill(false);
  };

  const handleRowClick = (data) => (evt) => {
    setOpenDetail(true);
  };

  const handleClickOpenTaxBill = (rowData) => {
    setSelectedRow(rowData);
    setOpenTaxBill(true);
  };

  const handleClickOpenFreeCouponOrder = () => {
    setOpenFreeCouponOrder(true);
  };

  const handleCloseFreeCouponOrder = () => {
    setOpenFreeCouponOrder(false);
  };

  const handleChangeTab = (event, newValue) => {
    setPageCnt(1);
    setRows([]);
    setValue(newValue);
  };

  useEffect(() => {
    getDataList();
  }, [page, value]);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        사용권 관리
      </Typography>
      <Grid container spacing={2}>
        <Grid item sx={{ width: '100%' }}>
          <Stack direction="row" spacing={2}>
            <LocalizationProvider dateAdapter={DateAdapter}>
              <DatePicker
                inputFormat={'yyyy-MM-DD'}
                label="발급 시작일"
                value={srchData.startYmd}
                onChange={(newValue) => {
                  setSrchData({ ...srchData, startYmd: newValue });
                }}
                renderInput={(params) => <TextField {...params} helperText={null} />}
                disableMaskedInput={true}
              />
              <DatePicker
                inputFormat={'yyyy-MM-DD'}
                label="발급 종료일"
                value={srchData.endYmd}
                onChange={(newValue) => {
                  setSrchData({ ...srchData, endYmd: newValue });
                }}
                renderInput={(params) => <TextField {...params} helperText={null} />}
                disableMaskedInput={true}
              />
            </LocalizationProvider>
            <TextField id="usernameSrch" variant="outlined" label="담당자명" value={srchData?.username || ''} onChange={handleChangeSrch} />
            <Button variant="contained" onClick={getDataList}>
              검색
            </Button>
          </Stack>
        </Grid>
      </Grid>
      <Box sx={{ width: '100%' }}>
        <Box display="flex" justifyContent="flex-end">
          <Button variant="contained" onClick={handleClickOpenFreeCouponOrder}>
            무료사용권
          </Button>
        </Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2 }}>
          <Tabs value={value} onChange={handleChangeTab} aria-label="basic tabs example">
            <Tab label="주문현황" id="simple-tab-0" aria-controls="simple-tabpanel-0" />
            <Tab label="주문완료" id="simple-tab-1" aria-controls="simple-tabpanel-1" />
            <Tab label="구매취소내역" id="simple-tab-2" aria-controls="simple-tabpanel-2" />
            <Tab label="무료사용권" id="simple-tab-3" aria-controls="simple-tabpanel-3" />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <DataListView label="미승인" rows={rows} columns={columns} page={page} pageCnt={pageCnt} setPage={setPage} onOpenDetail={handleClickOpenTaxBill} getDataList={getDataList} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <DataListView label="승인완료" rows={rows} columns={columnsApproved} page={page} pageCnt={pageCnt} setPage={setPage} onOpenDetail={handleClickOpenTaxBill} getDataList={getDataList} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <DataListView label="구매취소내역" rows={rows} columns={columnsCancel} page={page} pageCnt={pageCnt} setPage={setPage} onOpenDetail={handleClickOpenTaxBill} getDataList={getDataList} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <DataListView label="무료사용권" rows={rows} columns={columnsFree} page={page} pageCnt={pageCnt} setPage={setPage} onOpenDetail={null} getDataList={getDataList} />
        </TabPanel>
      </Box>
      {selectedRow?.id && <TaxBillDetail companyId={selectedRow?.companyId} orderId={selectedRow?.id} open={openTaxBill} handleClose={handleCloseDetail} getDataList={getDataList} page={page} />}
      <CouponDetail open={openDetail} handleClose={handleCloseDetail} companyId={selectedRow?.companyId} orderId={selectedRow?.id} />
      <FreeCouponOrder open={openFreeCouponOrder} handleClose={handleCloseFreeCouponOrder} getDataList={getDataList} handleChangeTab={handleChangeTab} />
    </Paper>
  );
}

const DataListView = (props) => {
  const { rows, columns, page, pageCnt, setPage, onOpenDetail, getDataList } = props;

  const [orderStepCdItem, setOrderStepCdItem] = useState([]);

  const getOrderStepCd = async () => {
    const response = await axios.get('/api/code/order_step');
    if (response.data) {
      setOrderStepCdItem(response.data);
    }
  };

  const handleOpenTaxBill = (row) => (e) => {
    onOpenDetail(row);
  };

  useEffect(() => {
    getOrderStepCd();
  }, []);

  return (
    <TableContainer component={'div'}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIdx) => (
            <TableRow hover key={row.id}>
              {columns.map((col, colIdx) => {
                const colId = col.id;
                const value = row[col.id];
                const prgStepCd = orderStepCdItem.find((t) => t.cdVal === row.prgStepCd);
                let cellValue = value;

                if (colId === 'taxbillAt' && !row.taxbillAt && row.createdAt) cellValue = '진행중..';
                if (colId === 'depositAt' && !row.depositAt && row.taxbillAt) cellValue = '입금대기중..';
                if (colId === 'approvalAt' && !row.approvalAt && row.depositAt) cellValue = '발행대기중..';
                if (colId === 'prgStep') {
                  let btnInfo = prgStepCd?.cdNm ? { variant: 'contained', btnNm: prgStepCd?.cdNm } : { variant: 'outlined', btnNm: '조회' };
                  let color = 'primary';
                  if (row.prgStepCd === 'CANCEL_CMPT') {
                    color = 'info';
                  }
                  if (row?.cancelReqAt && !row?.cancelCmptAt) {
                    return (
                      <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                        <Button variant={btnInfo.variant} onClick={handleOpenTaxBill(row)} fullWidth color="error">
                          주문취소요청
                        </Button>
                      </TableCell>
                    );
                  }
                  if (row.companionAt) {
                    return (
                      <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                        <Button variant={btnInfo.variant} onClick={handleOpenTaxBill(row)} fullWidth color="warning">
                          {btnInfo?.btnNm}
                        </Button>
                      </TableCell>
                    );
                  } else {
                    return (
                      <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                        <Button variant={btnInfo.variant} onClick={handleOpenTaxBill(row)} fullWidth color={color}>
                          {btnInfo?.btnNm}
                        </Button>
                      </TableCell>
                    );
                  }
                }
                if (colId === 'orderInfo') {
                  return (
                    <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                      <Button variant="outlined" onClick={handleOpenTaxBill(row)} fullWidth>
                        조회
                      </Button>
                    </TableCell>
                  );
                }
                return (
                  <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                    {col.format && typeof cellValue === 'number' ? col.format(cellValue) : cellValue}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Container maxWidth="sm" sx={{ mt: 2 }}>
        <Pagination count={pageCnt} page={page} onChange={(e, value) => setPage(value)} showFirstButton showLastButton />
      </Container>
    </TableContainer>
  );
};
